import _ from 'lodash';
import UserCustomColumns from '../../controllers/userCustomColumns';

class BaselineGrid {
  constructor() {
    this.instance = null;
    this.baselinesTasks = {};
    this.baselinesTasksCustomValues = {};
    this.baselinesTasksCustomColumns = [];
  }

  init(instance) {
    this.instance = instance;
    this.clearBaselineTasksCache();
  }

  getBaselineTask(id) {
    return this.baselinesTasks[id];
  }

  clearBaselineTasksCache() {
    this.baselinesTasks = {};
    this.baselinesTasksCustomValues = {};
    this.baselinesTasksCustomColumns = [];
  }

  addBaselineTask(baselineTask, projectBaselineData) {
    this.baselinesTasks[baselineTask.id] = baselineTask;
    this.baselinesTasksCustomColumns = projectBaselineData.userCustomColumnsData.columns;
    if (projectBaselineData.userCustomColumnsData.values[baselineTask.id]) {
      this.baselinesTasksCustomValues[baselineTask.id] = projectBaselineData.userCustomColumnsData.values[baselineTask.id];
    }
  }

  getUserCustomValuesMap() {
    // const valuesMap = {};

    // Object.keys(this.baselinesTasksCustomValues).forEach(taskId => {
    //   const customColumnValues = this.baselinesTasksCustomValues[taskId];

    //   customColumnValues.forEach(customColumnValueObject => {
    //     valuesMap[`${taskId}-${customColumnValueObject.column_id}`] = customColumnValueObject.task_value;
    //   });
    // });

    // return valuesMap;

    return this.baselinesTasksCustomValues;
  }

  getCustomValuesByTaskIdAndColumnId(taskId, columnId) {
    if (this.baselinesTasksCustomValues[taskId]) {
      return this.baselinesTasksCustomValues[taskId].filter(item => item.column_id === columnId);
    }

    return [];
  }

  getBaselineValue(task, column, cellValue) {
    const baselineTask = this.baselinesTasks[task.id];
    const columnsWithoutBaselineDiff = ['time_tracking', 'actual_cost'];
    let baselineValue = null;

    if (baselineTask && !_.includes(columnsWithoutBaselineDiff, column.name)) {
      baselineValue = column.template ? column.template(baselineTask, true) : baselineTask[column.name];
    }

    if (!baselineValue || _.isEqual(baselineValue, cellValue)) {
      if (column.isUserCustomColumn) {
        baselineValue = null;

        const baselineCustomValue = this.getBaselineUserCustomValue(task, column);
        const userCustomValue = UserCustomColumns.getUserCustomValue(task, column.name);

        if (_.toString(baselineCustomValue.text)) {
          baselineValue = _.toString(baselineCustomValue.text);
        }

        if (column.data_type === 'custom_number' && userCustomValue) {
          baselineCustomValue.value = +baselineCustomValue.value;
          userCustomValue.value = +userCustomValue.value;
        }

        if (_.isEqual(baselineCustomValue.value, userCustomValue.value)) {
          baselineValue = null;
        } else {
          if (column.data_type === 'custom_color' || column.data_type === 'custom_checkbox') {
            baselineValue = __('changed_custom_value');
          }
          if (column.data_type === 'custom_text' && !baselineCustomValue.value) {
            baselineValue = __('changed_custom_value');
          }
        }

        if (column.data_type === 'custom_date') {
          baselineValue = _.isEqual(baselineCustomValue.text, userCustomValue.text) ? null : baselineCustomValue.text.trim();
        }
      } else {
        baselineValue = null;
      }
    }

    return baselineValue;
  }

  getBaselineUserCustomValue(task, column) {
    const taskTypesForColumn = ['project', 'task', 'milestone'];
    let result = {
      text: '',
      value: null,
      toExcel: '',
    };

    if (!_.includes(taskTypesForColumn, task.type) || task.$level === 0) {
      return result;
    }

    if (!this.instance.config.multiview) {
      let columnData = _.find(this.baselinesTasksCustomColumns, { id: column.id });

      if (!columnData) {
        columnData = this.instance.ganttDataApi.getCustomColumnById(column.id);
      } else {
        columnData.type = columnData.custom_column_types_id;
        columnData.sub_type = columnData.custom_column_sub_types_id;
      }

      result = UserCustomColumns.prepareColumnValue(result, task, columnData, this.getCustomValuesByTaskIdAndColumnId(task.id, column.id), true);
    }

    return result;
  }
}

export default new BaselineGrid();
